// // import React, { Component } from 'react';
// // import { Select } from 'antd';
// // import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
// //
// // const { Option } = Select;
// // class DashboardChart extends Component {
// //   render() {
// //     const { data } = this.props;
// //     const dynamicChartData = (data && data.chartData) ? data.chartData : [];
// //     return (
// //       <div className="adminCard overviewCard">
// //         <div className="adminCardHeader">
// //           <div className="adminCardTitleBlock">
// //             <div className="adminCardTitle">Submission Overview</div>
// //             <div className="adminCardSubtitle">New and accepted manuscripts across all journals</div>
// //           </div>
// //           <a href="#" className="adminCardAction">View detailed report &rarr;</a>
// //         </div>
// //
// //         <div className="cardDivider"></div>
// //
// //         <div className="chartControls">
// //           <div className="chartLegend">
// //             <span className="legendItem">
// //               <span className="legendDot" style={{ backgroundColor: '#1f6b4f' }}></span> New submissions
// //             </span>
// //             <span className="legendItem">
// //               <span className="legendDot" style={{ backgroundColor: '#ed7b2f' }}></span> Accepted
// //             </span>
// //           </div>
// //           <Select defaultValue="12" style={{ width: 140 }} className="chartSelect">
// //             <Option value="12">Last 12 months</Option>
// //             <Option value="6">Last 6 months</Option>
// //           </Select>
// //         </div>
// //
// //         <div style={{ width: '100%', height: 260, marginTop: '8px' }}>
// //           <ResponsiveContainer>
// //             {/*<BarChart data={chartData} margin={{ top: 10, right: 10, left: -25, bottom: 0 }} barGap={6}>*/}
// //             <BarChart data={dynamicChartData} margin={{ top: 10, right: 10, left: -25, bottom: 0 }} barGap={6}>
// //               <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e9eeec" />
// //               <XAxis
// //                 dataKey="month"
// //                 stroke="#a1aaa6"
// //                 fontSize={12}
// //                 tickLine={false}
// //                 axisLine={{ stroke: '#f0f0f0' }}
// //               />
// //               <YAxis
// //                 stroke="#a1aaa6"
// //                 fontSize={11}
// //                 tickLine={false}
// //                 axisLine={false}
// //                 domain={[0, 240]}
// //                 ticks={[0, 60, 120, 180, 240]}
// //               />
// //               <Tooltip cursor={{ fill: 'rgba(0,0,0,0.01)' }} />
// //               <Bar dataKey="newSubmissions" fill="#1f6b4f" radius={[4, 4, 0, 0]} barSize={10} />
// //               <Bar dataKey="accepted" fill="#ed7b2f" radius={[4, 4, 0, 0]} barSize={10} />
// //             </BarChart>
// //           </ResponsiveContainer>
// //         </div>
// //       </div>
// //     );
// //   }
// // }
// //
// // export default DashboardChart;
//
// import React, { Component } from 'react';
// import { Select } from 'antd';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
//
// const { Option } = Select;
//
// class DashboardChart extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       monthsToShow: 12 // Default to showing 12 months
//     };
//   }
//
//   // Handle dropdown change
//   handleFilterChange = (value) => {
//     this.setState({ monthsToShow: parseInt(value, 10) });
//   };
//
//   render() {
//     const { data } = this.props;
//     const { monthsToShow } = this.state;
//
//     // 1. Extract data safely
//     let dynamicChartData = (data && data.chartData) ? data.chartData : [];
//
//     // 2. Slice the array to get only the last N months (e.g., last 6 or last 12)
//     if (dynamicChartData.length > 0) {
//       dynamicChartData = dynamicChartData.slice(-monthsToShow);
//     }
//
//     return (
//       <div className="adminCard overviewCard">
//         <div className="adminCardHeader">
//           <div className="adminCardTitleBlock">
//             <div className="adminCardTitle">Submission Overview</div>
//             <div className="adminCardSubtitle">New and accepted manuscripts across all journals</div>
//           </div>
//           <a href="#" className="adminCardAction">View detailed report &rarr;</a>
//         </div>
//
//         <div className="cardDivider"></div>
//
//         <div className="chartControls">
//           <div className="chartLegend">
//             <span className="legendItem">
//               <span className="legendDot" style={{ backgroundColor: '#1f6b4f' }}></span> New submissions
//             </span>
//             <span className="legendItem">
//               <span className="legendDot" style={{ backgroundColor: '#ed7b2f' }}></span> Accepted
//             </span>
//           </div>
//
//           {/* 3. Connect Select to component state */}
//           <Select
//             value={String(monthsToShow)}
//             onChange={this.handleFilterChange}
//             style={{ width: 140 }}
//             className="chartSelect"
//           >
//             <Option value="12">Last 12 months</Option>
//             <Option value="6">Last 6 months</Option>
//           </Select>
//         </div>
//
//         <div style={{ width: '100%', height: 260, marginTop: '8px' }}>
//           <ResponsiveContainer>
//             <BarChart data={dynamicChartData} margin={{ top: 10, right: 10, left: -25, bottom: 0 }} barGap={6}>
//               <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e9eeec" />
//               <XAxis
//                 dataKey="month"
//                 stroke="#a1aaa6"
//                 fontSize={12}
//                 tickLine={false}
//                 axisLine={{ stroke: '#f0f0f0' }}
//               />
//               <YAxis
//                 stroke="#a1aaa6"
//                 fontSize={11}
//                 tickLine={false}
//                 axisLine={false}
//                 domain={[0, 240]}
//                 ticks={[0, 60, 120, 180, 240]}
//               />
//               {/*<Tooltip cursor={{ fill: 'rgba(0,0,0,0.01)' }} />*/}
//               <Bar dataKey="newSubmissions" fill="#1f6b4f" radius={[4, 4, 0, 0]} barSize={10} />
//               <Bar dataKey="accepted" fill="#ed7b2f" radius={[4, 4, 0, 0]} barSize={10} />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     );
//   }
// }
//
// export default DashboardChart;

import React, { Component } from 'react';
import { Select } from 'antd';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import { ChartTimeframeOptions } from '../../../components/_utils/appUtils';

const { Option } = Select;

class DashboardChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthsToShow: 12 // Keeps the dropdown UI instantly in sync
    };
  }

  // Updates local UI state and fires the API trigger to the parent
  handleFilterChange = (value) => {
    const months = parseInt(value, 10);
    this.setState({ monthsToShow: months }, () => {
      if (this.props.onMonthFilterChange) {
        this.props.onMonthFilterChange(months);
      }
    });
  };

  render() {
    const { data } = this.props;
    const { monthsToShow } = this.state;

    // Data maps directly from the backend API, no local array slicing
    let dynamicChartData = (data && data.chartData) ? data.chartData : [];

    return (
      <div className="adminCard overviewCard">
        <div className="adminCardHeader">
          <div className="adminCardTitleBlock">
            <div className="adminCardTitle">Submission Overview</div>
            <div className="adminCardSubtitle">New and accepted manuscripts across all journals</div>
          </div>
          {/*<a href="#" className="adminCardAction">View detailed report &rarr;</a>*/}
        </div>

        <div className="cardDivider"></div>

        <div className="chartControls">
          <div className="chartLegend">
            <span className="legendItem">
              <span className="legendDot" style={{ backgroundColor: '#1f6b4f' }}></span> New submissions
            </span>
            <span className="legendItem">
              <span className="legendDot" style={{ backgroundColor: '#ed7b2f' }}></span> Accepted
            </span>
          </div>

          {/* Dynamically render options from your centralized utility */}
          <Select
            value={String(monthsToShow)}
            onChange={this.handleFilterChange}
            style={{ width: 140 }}
            className="chartSelect"
          >
            {ChartTimeframeOptions.map(option => (
              <Option key={option.value} value={String(option.value)}>
                {option.label}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ width: '100%', height: 260, marginTop: '8px' }}>
          <ResponsiveContainer>
            <BarChart data={dynamicChartData} margin={{ top: 10, right: 10, left: -25, bottom: 0 }} barGap={6}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e9eeec" />
              <XAxis
                dataKey="month"
                stroke="#a1aaa6"
                fontSize={12}
                tickLine={false}
                axisLine={{ stroke: '#f0f0f0' }}
              />
              <YAxis
                stroke="#a1aaa6"
                fontSize={11}
                tickLine={false}
                axisLine={false}
                domain={[0, 240]}
                ticks={[0, 60, 120, 180, 240]}
              />
              <Tooltip
                cursor={{ fill: 'rgba(0,0,0,0.01)' }}
                formatter={(value, name) => [
                  value,
                  name === 'newSubmissions' ? 'New submissions' : 'Accepted'
                ]}
              />
              <Bar dataKey="newSubmissions" fill="#1f6b4f" radius={[4, 4, 0, 0]} barSize={10} />
              <Bar dataKey="accepted" fill="#ed7b2f" radius={[4, 4, 0, 0]} barSize={10} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default DashboardChart;